module.exports = __webpack_public_path__ + "assets/img/hill-5.0db656bb.png";